import React from 'react'
import {
  useMap,
  WMSTileLayer,
  FeatureGroup,
  GeoJSON,
} from 'react-leaflet'
import L from 'leaflet'

import { useDebounce } from 'usehooks-ts'
import { find } from 'lodash'
import { useFeatureUrl, useFetchFeatureStats } from '@graniot/common/adapters/sentinel'
import {
  generateGetFeatureInfoLink1,
} from '@graniot/common/utils/parcels'


function bboxToWKT(bboxString) {
  // Split the bbox string into an array of coordinates
  const coordinates = bboxString.split(',').map(Number);

  // Destructure the coordinates for clarity
  const [minX, minY, maxX, maxY] = coordinates;

  // Construct the POLYGON WKT string
  const wkt = `POLYGON(( ${minX} ${minY}, ${maxX} ${minY}, ${maxX} ${maxY}, ${minX} ${maxY}, ${minX} ${minY} ))`;

  return wkt;
}

function computeLatLngBounds(geojsonList) {
  const latLngList = []

  geojsonList.forEach((geojson) => {
    if (geojson.geometry.type === 'Polygon') {
      geojson.geometry.coordinates.forEach((ring) => {
        ring.forEach((coord) => {
          latLngList.push(L.latLng(coord[1], coord[0]))
        })
      })
    }
  })

  return L.latLngBounds(latLngList)
}

export default function WMSLayer({ layer, farms, selectedResolution, date, handleOpenDialog }) {

  let baseUrl = `${process.env.REACT_APP_BASE_URL_IMAGES}${selectedResolution.instance_id}?`
  const map = useMap()
  const groupRef = React.useRef()
  const [featureData, setFeatureData] = React.useState(null)
  const debouncedFeatureData = useDebounce(featureData, 300)
  const checkedFarms = farms.filter((farm) => farm.checked)
  const geojsonList = checkedFarms.flatMap((f) =>
    f.farm_parcels.features.filter((f) =>
      find(f.properties.parcelresolution_set, {
        resolution: selectedResolution.id,
      })
    )
  )
  const bounds = computeLatLngBounds(geojsonList, selectedResolution)

  React.useEffect(() => {
    if (groupRef?.current) groupRef.current.bringToFront()
  }, [groupRef])


  /* const { data: stats, isLoading: statsLoading, refetch: statsRefetch } = useFetchFeatureStats(debouncedFeatureData)


  React.useEffect(() => {
    const indexValue =
      stats?.length > 0
        ? stats[0]?.data[0]?.outputs?.data?.bands?.B0?.stats?.mean
        : undefined
    const isValidNumber = !isNaN(parseFloat(indexValue));
    const result = isValidNumber ? parseFloat(indexValue).toFixed(3) : undefined;
    if (result && debouncedFeatureData?.coordinates) {
      var tooltip = (`Value: <b style="background:  color: 'black'; font-size:16px">${result}</b><br />`)
      if (date) tooltip += (`Date: <b style="background:  color: 'black'; font-size:16px">${date}</b><br />`)
      groupRef.current
        .bindTooltip(tooltip)
        .openTooltip(debouncedFeatureData.coordinates)
    } else {
      groupRef.current?.unbindTooltip()
    }
  }, [stats]) */

  const onEachFeature = (feature, layerLeaflet) => {
    layerLeaflet.on({
      click: (e) => {
        handleOpenDialog({
          img_url: null,
          layer: 'Parcels',
          parcel: feature,
        })
      },
      mousemove: (e) => {
        const size = map.getSize()
        setFeatureData({
          coordinates: e.latlng,
          parcel_id: feature.id,
          layer: layer.name,
          maxcc: 100,
          date: date,
        })
      },
    })
  }

  if (geojsonList.length < 4) {
    return (
      <FeatureGroup key={'multi-wms' + checkedFarms[0].id} ref={groupRef}>
        {geojsonList.map((p) => (
          <>
            <WMSTileLayer
              key={`${p.id}-${date}`}
              ref={groupRef}
              layers={layer.name}
              url={`https://g8a078u1g6.execute-api.eu-west-1.amazonaws.com/app/wms/${selectedResolution.instance_id}?`}
              transparent={true}
              format="image/png"
              maxZoom={32}
              geometry={'POLYGON(' + p.geometry.coordinates.map(function(ring) {
                return '(' + ring.map(function(p) {
                  return p[0] + ' ' + p[1];
                }).join(', ') + ')';
              }).join(', ') + ')'}
              time={date}
              crs={L.CRS.EPSG4326}
            />
            <GeoJSON
              data={p}
              color="transparent"
              name="Parcels"
              onEachFeature={onEachFeature}
              ref={groupRef}
            />
          </>
        ))}
      </FeatureGroup>
    )
  }

  return (
    <>
      <WMSTileLayer
        key={'single-wms' + checkedFarms[0].id + date}
        ref={groupRef}
        layers={layer.name}
        url={`https://g8a078u1g6.execute-api.eu-west-1.amazonaws.com/app/wms/${selectedResolution.instance_id}?`}
        transparent={true}
        format="image/png"
        maxZoom={32}
        time={date}
        geometry={bboxToWKT(bounds.toBBoxString())}
        crs={L.CRS.EPSG4326}
      />
      <GeoJSON
        data={geojsonList}
        color="transparent"
        name="Parcels"
        onEachFeature={onEachFeature}
        ref={groupRef}
      />
    </>
  )
}
